export enum AccessRuleEnum {
  COMPANY = "Company",
  PEOPLE = "People",
  RESOURCES = "Resources",
  CONFIGURATIONS = "Configurations",
  TEMPLATES = "Templates",
  VIDEOCALL = "VideoCall",
  MANAGEMENT = "Management",
}

export enum ResourceGroupNameEnum {
  DASHBOARD = "Dashboard",
  OVERVIEW = "Overview",
  STATS = "Stats",
  GENERAL = "General",
  ANALYTICS = "Analytics",
  SALES = "Sales",
  OPERATIONS = "Operations",
  WAREHOUSE = "Warehouse",
  REPORTS = "Reports",
  NETWORK = "Network",
  SETTINGS = "Settings",
  MEMBERS = "Members",
}

export enum ResourceObjectTypeEnum {
  RESOURCE = "resource",
  FEATURE = "feature",
  FUNCTION = "function",
}

export enum ResourceName {
  COMPANY = "Company",
  PEOPLE = "People",
  RESOURCES = "Resources",
  TEMPLATES = "Templates",
  CONFIGURATIONS = "Configurations",
  DISPATCH = "Dispatch",
  STORAGE_BOX_AND_UNIT = "Storage Box And Unit",
  MOVEMENT = "Movement",
  TRANSSHIPMENT = "Transshipment",
  SHIPMENTS = "Shipments",
  ORDERS = "Orders",
  QUOTE = "Quote",
  LEADS = "Leads",
  INVOICES = "Invoices",
  NETWORK = "Network",
  CUSTOMERS = "Customers",
  AGENTS = "Agents",
  ACCOUNTS = "Accounts",
  SUPPLIERS = "Suppliers",
  ANALYTICS = "Analytics",
  BOOKING = "Booking",
}

export enum ResourceCanEnum {
  EDIT = "edit",
  VIEW = "view",
}
